import { userManagementRoute } from '@/modules/administration/user-management/routes';
import { createRoute, redirect } from '@tanstack/react-router';

export const userManagementIndexRoute = createRoute({
  getParentRoute: () => userManagementRoute,
  path: '/',
  wrapInSuspense: true,
  beforeLoad: () => {
    throw redirect({
      to: '/admin/user-management/users',
    });
  },
});
